import { CatalogDataResponseCatalogNumbersItem, CatalogDataResponseItem, CatalogDataResponsePricesItem } from "../types";

const FALLBACK_LENS_TYPE_TEXT = 'Jednoogniskowe'

// Field A (name)
export const getName = (data: CatalogDataResponseItem, additionalPart?: string | null) =>
    additionalPart
        ? `${data.name} ${additionalPart}`
        : data.name

// Field B (catalog number)
export const getSingleCatalogNumber = (data: CatalogDataResponseCatalogNumbersItem) => data.number;

export const getCatalogNumbers = (data: CatalogDataResponseItem) => data.catalogNumbers;

// Field C, D
// CONSTANT - ALWAYS 0

// Field E
// CONSTANT - ALWAYS 8

// Field F
export const getBuyPriceFromPricesItem = (data: CatalogDataResponsePricesItem) => data.buyPrice;

// Field G
export const getSellPriceFromPricesItem = (data: CatalogDataResponsePricesItem) => data.sellPrice;

// Field H
// Producer - it will probably be taken from form value

// Field I (is photochromic)
export const getIsPhotochromic = (data: CatalogDataResponseItem) => {
    const requiredNameParts = ['transitions', 'acclimates'];

    return requiredNameParts.some((part) => data.name.toLowerCase().includes(part));
}

// Field J
// CONSTANT - always 0

// Field L (is polarising)
export const getIsPolarising = (data: CatalogDataResponseItem) => {
    const requiredNameParts = ['polaryzacja'];

    return requiredNameParts.some((part) => data.name.toLowerCase().includes(part))
} 

export const getColors = (data: CatalogDataResponseItem) => data.colors;

// Field M (polarisign colors)
// TODO analyse how to obtain colors for polarising

// Field N
// Constant - always "Korekcyjne"

// Field O (material)
export const getMaterial = (data: CatalogDataResponseItem) => {
    const mineralMaterial = 'mineralne';
    const isMineral = data.remarks.some((remark) => remark.toLowerCase().includes(mineralMaterial));

    return isMineral ? 'Mineralne' : 'Organiczne'
}

// Field P (construction - "spherical" or "aspherical")
export const getConstruction = (data: CatalogDataResponseItem) => {
    // We need to check if name contains standalone "AS"
    const regex = /(?<!\w)AS(?!\w)/
    const isAspherical = regex.test(data.name);

    return isAspherical ? 'Asferyczne' : 'Sferyczne'
}


// Field Q (type)
type ConstructionConfigItem = {
    name: string;
    requiredPhrasesRegexList: RegExp[];
    getProperty: (data: CatalogDataResponseItem) => unknown;
};

const constructionConfig: ConstructionConfigItem[] = [
    {
        name: 'Relaksacyjne',
        requiredPhrasesRegexList: [/wspiera wysiłek akomodacyjny oczu/],
        getProperty: (data: CatalogDataResponseItem) => data.remarks
    },
    {
        name: 'Progresywne',
        requiredPhrasesRegexList: [
            /XR pro/,
            /XR track/,
            /XR 4D/,
            /XR Design/,
            /Physio/,
            /Comfort MAX/,
            /Liberty/,
            /PAL/,
            /Varilux Exceptio/,
            /Varilux Omega/,
            // REMARK - no phrase found in catalog
            /Varilux z segmentem do bliży w górnej części soczewki/
        ],
        getProperty: (data: CatalogDataResponseItem) => data.name
    },
    {
        name: 'Biurowe',
        requiredPhrasesRegexList: [
            /Digitime/,
            /Interview/
        ],
        getProperty: (data: CatalogDataResponseItem) => data.name
    },
    {
        name: 'Dwuogniskowe',
        requiredPhrasesRegexList: [
            /Telarc/,
            /ST 28/,
            /Bifo/,
            /Tele/,
            /Soczewka dwuogniskowa/,
            /Telemil/
        ],
        getProperty: (data: CatalogDataResponseItem) => data.name
    }

]

export const getType = (data: CatalogDataResponseItem) => {
    const relevantConfigItem = constructionConfig.find((configItem) => {
        const currentData = configItem.getProperty(data) as string | string[];

        if (typeof currentData === 'string') {
            return configItem.requiredPhrasesRegexList.some((regex) => regex.test(currentData))
        } else {
            return currentData.some((dataItem) => 
                configItem.requiredPhrasesRegexList.some((regex) => regex.test(dataItem))
        )}
    })

    return relevantConfigItem?.name || FALLBACK_LENS_TYPE_TEXT;
}

// Field R (is colored)
export const getIsColored = (data: CatalogDataResponseItem) => {
    const regex = /(polaryzac|kolor|sun)/i;

    return regex.test(data.name)
}


// Field S, T, U, V
// CONSTANT - ALWAYS 0

// Field W (shell)
export const getShellList = (data: CatalogDataResponseItem) => data.prices.map((price) => price.shell).join(', ')

export const getPrices = (data: CatalogDataResponseItem) => data.prices;

export const getColorations = (data: CatalogDataResponseItem) => data.colorations

